import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom'; // Import useParams
import Api from "../../../helpers/Api";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import AppLayout from '../../../components/layout/AppLayout';
import SubHeader from '../../../components/subheader/SubHeader';
import styled from "styled-components";
import AppTheme from '../../../themes/AppTheme';
import LoadingPage from "../../loading/LoadingPage";

export const Container = styled.div`
    border-radius: 5px;
    border: 1px solid  ${AppTheme.header.colors.tableBorder};
    background:  ${AppTheme.header.colors.whiteColor};
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
    float:left;
    width:100%;
    padding:0;
    >form{
        background:${AppTheme.header.colors.whiteColor};
        padding:0px 15px 20px 15px;
    }
`;

export const FormGroup = styled.div`
    padding:20px 0px;
    border-bottom:1px solid ${AppTheme.header.colors.tableBorder};
    >div{
        margin-bottom:0px;
    }
`;

export const ButtonContainer = styled.div`
    width:100%;
    display:flex;
    align-items:center;
    justify-content:flex-end;
    margin-top:20px;
    >a{
        text-decoration:none;
        border-radius: 6px;
        border: 1px solid  ${AppTheme.header.colors.inputBorder};
        background:${AppTheme.header.colors.whiteColor};
        /* Shadow/xs */
        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
        height:40px;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:0 10px;
        margin-right:15px;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        color:${AppTheme.header.colors.blackColor};
    }
    >div{
        margin-top:0px;
        >button{
            margin-bottom:0px;
            height:40px;
            padding:0 15px;
            border-radius:6px;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
        }
    }
    
`;

const CreateSchool = () => {
    const {id} = useParams(); // Get the :id parameter from the route
    const navigate = useNavigate();
    const [schoolName, setSchoolName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [initialising, setInitialising] = useState(true);

    useEffect(() => {
        // If id is present, load the existing school data
        if (!id) {
            setInitialising(false);
            return;
        }

            setLoading(true);
            Api.getSchool(id).then(school => {
                setSchoolName(school.name);
                setLoading(false);
            }).catch(err => {
                setError('Failed to load school. Please try again.');
                setLoading(false);
            }).finally(()=>{
                setInitialising(false);
            })

    }, [id]);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        let school;
        try {
            if (!schoolName.trim()) {
                setError('School name cannot be empty.');
                setLoading(false);
                return;
            }
            if (id) {
                // If id is present, update the existing school
                school = await Api.updateSchool(id, schoolName);
            } else {
                // If no id, create a new school
                school = await Api.createSchool(schoolName);
            }
            navigate(`/schools`);
        } catch (error) {
            setError('Failed to process school. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (initialising) return <LoadingPage/>

    return (
        <AppLayout>
            <Container>
                <SubHeader
                    heading={id ? 'Edit School' : 'Create School'}
                    description={id ? 'Edit Credential Issuing Schools' :'Set Up New Credential Issuing Schools'}
                />
                <form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Input
                            label="Name of School"
                            astricSign='*'
                            type="horizontalinput"
                            value={schoolName}
                            onChange={(e) => setSchoolName(e.target.value)}
                            name="schoolName"
                            placeholder={'Enter school name'}
                            //  error={error.schoolName}
                        />
                    </FormGroup>
                    {/* <FormGroup>
                        <Input
                            label="About, A write-up about the event, programme, or credential (less than 50 words)."
                            type="textarea"
                            name="about"
                            placeholder={'Example: Speaker Badge Global DevOps Summit or Degree certificate'}
                            error={error}
                        />
                    </FormGroup> */}
                    <ButtonContainer>
                        <Link to={`/schools`}>
                            Cancel
                        </Link>
                        <Button disabled={loading} type={'submit'} loading={loading}
                                label={id ? "Update School" : "Create"}/>


                    </ButtonContainer>

                    {error && <div style={{color: 'red'}}>{error}</div>}
                </form>
            </Container>
        </AppLayout>
    );
};

export default CreateSchool;
